<template>
  <div v-if="pdf_report">
    <div class="page">
      <div class="track-info">
      <div class="top_info">
        <div class="title">
          <img src="@/assets/icons/icon-awesome-youtube.png" class="youtube-icon" v-if="challenge_type == 'YouTube'"/>
          <img src="@/assets/icons/report-instagram.png" class="youtube-icon" v-if="challenge_type == 'Instagram'"/>
          <img src="@/assets/icons/report-shorts.png" class="youtube-icon" v-if="challenge_type == 'Shorts'"/>
          <img src="@/assets/icons/report-tiktok.png" class="youtube-icon" v-if="challenge_type =='TikTok'"/>
          Campaign Report
          <div class="icon-wrapper" v-if="type == 'track'">
            <img src="@/assets/icons/notes.svg" />
          </div>
          <div class="icon-wrapper" v-if="type == 'brand'">
            <img src="@/assets/icons/brand_report.svg" class="brand_icon"/>
          </div>
        </div>
        <div class="download_date">{{ pdf_report.download_date | date }}</div>
      </div>
      <div class="artist_info">
        <div class="artist-top">
          <div class="artist_image">
            <img
              id="avatar"
              :src="artist_image"
              crossorigin="*"
            />
            <img
              class="image_cover"
              src="@/assets/icons/avatar-cover.png"
              crossorigin="*"
            />
          </div>
          <div class="artist_track" >
            <p class="artist_paragraph">{{ artist }}</p>
            <p class="track_paragraph">{{ track }}</p>
          </div>
        </div>
        <div class="budget">
          <div class="budget__period">
            <div class="campaign_title">
              Campaign period
            </div>
            <p class="date_paragraph">
              {{ pdf_report.date_start | date }} -
              {{ pdf_report.date_end | date }}
            </p>
          </div>
          <div class="budget__campaign" v-if="pdf_report.budget > 0">
            <div class="campaign_budget">
              Campaign Budget:
              <span v-if="pdf_report.budget">${{ (pdf_report.budget/10).toFixed(2) }}</span><span v-else>$0.00</span>
            </div>
            <div class="budget_remaining">
              Budget Remaining:
              <span v-if="pdf_report.budget">${{ ((pdf_report.budget-pdf_report.total_wallet)/10).toFixed(2) }}</span><span v-else>$0.00</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="campaign-wrapper">
      <div class="campaign-info">
        <div>
          <div class="title">
            Campaign Highlights:
          </div>
          <div class="info">Videos: <span>{{ pdf_report.total_video_count }}</span></div>
          <div class="info">Views Achieved: <span>{{ commaNum(pdf_report.total_play_count) }}</span></div>
          <div class="info">Followers Reached: <span>{{ commaNum(pdf_report.subscribers) }}</span></div>
          <div class="info">CPM (Paid and Free): <span v-if="actualCpm">${{ actualCpm.toFixed(2) }}</span><span v-else>$0.00</span></div>
          <div class="info">CPM (Paid): <span v-if="paidCpm">${{ paidCpm.toFixed(2) }}</span><span v-else>$0.00</span></div>
        </div>
        <div>
          <div class="track_image">
            <img
              :src ="track_image"

              crossorigin="*"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="chart-wrapper">
      <div class="charts">
        <div>
          <h2>Top Countries</h2>
          <div class="flex-space-between d-lg-grid grid-order-chart">
            <GChart
              type="PieChart"
              :data="countries_chart"
              :options="chart_pdf"
            />
            <div class="popularity">
              <div class="popularity-wrap">
                <div
                  class="flex-space-between popularity-info"
                  v-for="(c, index) in pdf_report.countries"
                  :key="index"
                >
                  <div class="flex-center">
                    <div
                      class="color-square"
                      :style="`background: ${colors[index]}`"
                    ></div>
                    <p class="name">{{ c.country }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="footer">
        <p>
          © 2023 SoundVault Ltd.
        </p>
        <a href="https://syncvault.com/">
          <img src="@/assets/icons/syncvault-pdf-logo.png" />
        </a>
      </div>
    </div>
    <div
      class="page"
      v-for="(page, page_index) in videoPages"
      :key="page_index"
    >
      <div class="videos-page">
        <div class="text-box-page" v-if="page_index == 0">
          <h1 id="primary-color">Campaign Videos</h1>
        </div>
        <div class="table" :class="{ big: page_index != 0 }">
          <table>
            <tr>
              <th>No.</th>
              <th>Videos</th>
              <th>Views</th>
              <th v-if="pdf_report.budget > 0">Paid</th>
<!--              <th v-if="pdf_report.gp === 1">GP</th>
              <th v-if="pdf_report.shoutout === 1">Shout Out</th>-->
              <th  v-if="pdc == true">Publish Date</th>
            </tr>
            <tr
              v-for="(video, index) in pdf_report.videos.slice(
              page_index * max_videos,
              page_index * max_videos + max_videos
            )"
              :key="index"
            >
              <td>
                <strong>{{ index + page_index * max_videos + 1 }}. </strong>
              </td>
              <td id="link">
                <a
                  :href="video.link"
                  target="_blank"
                >
                  {{ video.link.slice(0, 85) }}
                </a>
              </td>
              <td class="p0">
                {{ commaNum(video.play_count) }}
              </td>
              <td class="p0" v-if="pdf_report.budget > 0">
                <span>${{ (video.wallet/10).toFixed(2) }}</span>
              </td>
<!--              <td class="p0" v-if="pdf_report.gp === 1">
                ${{ video.guaranteed_payment.toFixed(2) }}
              </td>
              <td class="p0" v-if="pdf_report.shoutout === 1">
                ${{ video.shoutout.toFixed(2) }}
              </td>-->
              <td v-if="pdc == true">
                {{ video.publish_date | date }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="footer">
        <p>
          © 2023 SoundVault Ltd.
        </p>
        <a href="https://syncvault.com/">
          <img src="@/assets/icons/syncvault-pdf-logo.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { GChart } from 'vue-google-charts'

export default {
  props: {
    type: String,
    pdf_report: { type: Object, default: () => ({}) },
    challenge_type: String,
    countries_chart:  Array,
    chart_pdf: Object,
    pdc: {
			type: Boolean,
			default: 0,
		}
  },
  components: {
    GChart
  },

  data() {
    return {
      max_videos: 11,
      apiUrl: process.env.VUE_APP_API_HOST,
      colors: [
        '#4472C4',
        '#8687D2',
        '#B69FDF',
        '#DEBAEB',
        '#A9DAE7',
        '#A7E5FF',
        '#00CAFF',
        '#00F2EA',
        '#00D3A5',
        '#00FF00',
      ]
    }
  },
  computed: {
    videoPages() {
      if (this.pdf_report.videos) {
        return this.pdf_report.videos.length > this.max_videos
          ? Math.ceil(this.pdf_report.videos.length / this.max_videos)
          : 1
      }
    },
    artist() {
      if (this.type === 'track') {
        return this.pdf_report.music_performer;
      } else if (this.type === 'brand') {
        return this.pdf_report.brand_company_name;
      } else {
        return '';
      }
    },
    track() {
      if (this.type === 'track') {
        return this.pdf_report.music_title;
      } else if (this.type === 'brand') {
        return this.pdf_report.brand_name;
      } else {
        return '';
      }
    },
    artist_image() {
      if (this.type === 'track') {
        return `${this.apiUrl}/storage/artists/` + this.pdf_report.artist_image_url;
      } else if (this.type === 'brand') {
        return this.pdf_report.brand_logo;
      } else {
        return '';
      }
    },
    track_image(){
      if (this.type === 'track') {
        return this.pdf_report.music_image_url;
      } else if (this.type === 'brand') {
        return this.pdf_report.brand_image;
      } else {
        return '';
      }
    },

    actualCpm() {
      if (this.pdf_report) {
        if (+this.pdf_report.total_play_count > 0) {
          return parseFloat(((this.pdf_report.budget / 10) / this.pdf_report.total_play_count) * 1000)
        }
      }
      return 0
    },

    paidCpm() {
      if (this.pdf_report) {
        if (this.pdf_report.videos.length > 0) {

          let freeViews = 0

          this.pdf_report.videos.forEach(video => {
            if (video.status !== 1) freeViews+= +video.play_count
          })

          if (+this.pdf_report.total_play_count > 0) {
            const totalViews = +this.pdf_report.total_play_count - freeViews
            return ((this.pdf_report.budget / 10) / totalViews) * 1000
          }
        }
      }
      return 0
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 795px;
  height: 1122px;
  background: white;
  position: relative;
  color: #220E61;
  font-family: 'Nunito Regular';
  .track-info{
    padding: 20px 50px 10px;
  }
  .top_info{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title{
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: 900;
      font-size: 30.4104px;
      line-height: 41px;
      color: #220E61;
      .youtube-icon{
        height: 35px;
        margin-right: 15px;
      }
      .icon-wrapper{
        margin-left: 30px;
      }
    }

    .download_date{
      font-weight: 900;
      font-size: 16.1949px;
      line-height: 22px;
      color: #220E61;
    }
  }
  .artist_info{
    display: flex;
    flex-direction: column;
    .artist-top{
      display: flex;
      .artist_image{
        position: relative;
        width: 153px;
        height: 161px;
      }
      .artist_track{
        justify-content: center;
        display: flex;
        flex-direction: column;
        margin-left: 43px;
        .artist_paragraph, .track_paragraph{
          font-size: 32.3898px;
          line-height: 32px;
          margin: 0;
        }
        .artist_paragraph{
          font-weight: 700;
          margin-bottom: 18px;
        }
        .track_paragraph{
          font-weight: 900;
        }
      }
    }
    .budget{
      display: flex;
      justify-content: space-between;
      &__period{
        .campaign_title{
          font-weight: 400;
          font-size: 20px;
          line-height: 32px;
        }
        .date_paragraph {
          font-weight: 700;
          font-size: 18px;
          line-height: 32px;
          margin: 0;
        }
      }
      &__campaign{
        font-weight: 400;
        font-size: 20px;
        line-height: 32px;
        span{
          font-weight: 900;
        }
      }
    }
  }
  .campaign-wrapper{
    background: rgba(134, 135, 210, 0.1);
    padding: 30px 50px;
  }
  #avatar {
    width: 153px;
    height: 161px;
   /* background-size: cover;
    background-position: center center;*/
  }
  .image_cover{
    top: 0;
    position: absolute;
    left: 0;
    width: 153px;
    height: 161px;
  }

  .campaign-info {
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: 700;
      font-size: 24px;
      line-height: 24px;
      margin-bottom: 1rem;
    }

    .info {
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;

      span {
        font-weight: 900;
      }
    }

    .track_image {
      img {
        width: 228px;
        border-radius: 6.47796px;
      }
    }
  }
.btn-vc {
display: flex;
margin-top:50px;
&:before {
  content: ' ';
  position: absolute;
  border: 2px solid #ffa400;
  width: 255px;
  top: -17px;
  opacity: 1;
  left: -7px;
  z-index: -1;
  height: 29px;
  border-radius: 23px;
  font-size: 15px;
  padding: 12px 25px;
  background: white;
}
a {
  width: auto;
  border: 1px solid #ffa400;
  border-radius: 17px;
  color: white;
  font-size: 14px;
  padding: 11px 26px;
  background: #ffa400;
  font-family: 'Nunito SemiBold';
}
}
.charts {
display: flex;
justify-content: center;
align-items: center;
margin: 1rem auto;
position: relative;
div {
  h2 {
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    margin: 1rem 0 1rem;
    //margin-right: calc(100% - 351px);
  }
}
}
.videos-logo {
  position: absolute;
  height: 35px;
  top: -3rem;
  right: 12%;
}
.table {
position: relative;
table {
  font-family: 'Nunito SemiBold';
  border-collapse: collapse;
  width: 81%;
  margin: 2.5rem 2rem 0 68px;
  text-align: center;
  color: #0c0526;
  border-collapse: collapse;
  border-radius: 7px;
  overflow: hidden;
  #link {
    text-align: left;
    display: flex;
    padding: 9px;
    min-height: 37px;
    align-items: center;
    color: #252525;
    font-family: 'Nunito Light';
    height: 2.6em;
    text-overflow: ellipsis;
    overflow: hidden;
    a {
      color: #5579d3;
      text-decoration: underline;
      cursor: pointer;
      padding-left: 8px;
      font-family: 'Nunito Regular';
      word-wrap: break-word;
      word-break: break-all;
    }
  }
  td,
  th {
    padding: 8px;
    border-left: 2px solid #fff;
    padding: 1em;
    background: #f9f9f9;
    border-bottom: 2px solid #fff;
  }
  th {
    padding-top: 12px;
    color: #4b4b4b;
    padding-bottom: 12px;
    font-family: 'Nunito Regular';
    background-color: #f5f4f4;
  }
  td {
    font-size: 14px;
    position: relative;
    small.vc-spent {
      font-family: 'Nunito SemiBold' !important;
      color: #1b1b1b;
      font-size: 12px !important;
      display: block;
      text-align: center;
    }
    span.gold {
      color: #ffa400;
    }
    span.green {
      color: #2dfb06;
    }
  }
}
}
.big {
table {
  margin: 1rem 2rem 0 68px;
}
}
.footer {
display: flex;
justify-content: space-between;
padding: 0 50px;
position: absolute;
bottom: 50px;
width: calc(100% - 100px);
p {
  margin: 0;
  font-weight: 700;
  font-size: 10px;
  line-height: 14px;
  opacity: 0.75;
}
a {
  font-family: 'Nunito Regular';
}
}
#vc-color {
color: #ffa400;
}
#primary-color {
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  color: #220E61;
}
}
.videos-page{
padding: 50px;
}
.chart-wrapper{
padding: 0 50px;
}
.page .top_info .title, .page .top_info .download_date, .page .artist_info .artist-top .artist_track .track_paragraph, .page .artist_info .budget__campaign span{
  font-family: "Nunito ExtraBold";
  font-weight: 900;
}
.popularity{
  width: 100px;
  font-size: 12px;
  vertical-align: middle;
  margin-top: 60px;
  margin-left: 0 !important;
}
.popularity .popularity-info {
  width: 250px;
  margin-bottom: 4px;
}
.color-square {
  width: 15px;
  height: 15px;
  -ms-flex-item-align: center;
  align-self: center;
  border-radius: 3px;
}
.brand_icon{
  width: 126px;
  height: 129px;
}
</style>
